import React, { useEffect, useState } from 'react'
import Report from '../../components/Report'
import { Accordion, Button } from 'react-bootstrap'
import { extractData, prefix } from '../../../utils/index_tagging_tool'
import { api } from '../../../utils/index'
import Loading from '../../components/Loading'
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import Header from '../../../components/Headers/Header'
import { getReportClientName } from '../../utils/reportClient'
import { filterClientNamesBySearch, hasClientSearch } from './listingUtils'

const Listing = () => {
  const [reports, setReports] = useState([]);
  const [clientSearch, setClientSearch] = useState('');

  const loadReports = () => {
    api.get(prefix + 'reports/')
      .then(extractData)
      .then((data) => {
        setReports(data);
      })
      .catch(console.log);
  };

  useEffect(() => {
    // document.title = 'Tagging tool'; // Replaced by SetTitle component
    loadReports();
  }, []); // Empty dependency array ensures this runs once on mount

  const getReportsClients = () => {
    let clients = [];
    if (reports.length > 0 && reports) {
      clients = reports
        .map((x) => getReportClientName(x))
        .filter((client) => client !== '');
      clients = [...new Set(clients)];
    }
    return clients.sort();
  };

  const visibleClients = filterClientNamesBySearch(getReportsClients(), clientSearch);
  const isFilteringClients = hasClientSearch(clientSearch);

  return (
    <>
      <Header iconClass="fa-solid fa-tags fa-xl" title="Tagging Tool" />
      {/*<PageTitle title="Reports" />*/}
      <Row style={{ marginBottom: "100px" }} className="justify-content-center AppTaggingTool">
        <Col xs={8}>
          <Card className="shadow bg-secondary">
            <CardHeader className="bg-white">
              <h1 className="mb-0">Clienti</h1>
              <p className="w-subtitle pt-4 pl-2 mb-0">
                Clicca su un cliente per visualizzare gli studikw associati
              </p>
              <FormGroup className="pt-4 pl-2 pr-2 mb-0" style={{ maxWidth: '420px' }}>
                <Label for="tagging-tool-client-search">Cerca cliente</Label>
                <Input
                  id="tagging-tool-client-search"
                  type="text"
                  placeholder="Digita il nome cliente"
                  value={clientSearch}
                  onChange={(event) => setClientSearch(event.target.value)}
                />
              </FormGroup>
            </CardHeader>

            <div className="mr-5 ml-5 mb-2">
              {reports.length > 0 ? (
                visibleClients.length > 0 ? visibleClients.map((client) => {
                  return (
                    <Accordion defaultActiveKey="0" key={client}> {/* Added key here for the Accordion */}
                      <Card> {/* Removed redundant key={client} from Card */}
                        <CardHeader>
                          <Accordion.Toggle
                            as={Button}
                            variant="link"
                            eventKey={client}
                            className="shadow-none"
                          >
                            {client}{' '}
                          </Accordion.Toggle>
                        </CardHeader>

                        <Accordion.Collapse key={client} eventKey={client}>
                          <CardBody>
                            <Accordion defaultActiveKey="0">
                              {reports.length > 0 ? ( // This check is a bit redundant here, but kept for directness
                                reports
                                  .filter(
                                    (x) => getReportClientName(x) === client
                                  )
                                  .map((repo) => {
                                      return <Report key={repo.id} repo={repo} />;
                                  })
                              ) : (
                                <Loading />
                              )}
                            </Accordion>
                          </CardBody>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  );
                }) : <p className="mt-3 mb-0 text-muted">Nessun cliente trovato.</p>
              ) : (
                <Loading />
              )}
            </div>
          </Card>

          <br />

          <Card className="shadow pb-20 bg-secondary">
            <CardHeader className="bg-white">
              <h1 className="mb-0">Studikw singoli</h1>
              <p className="w-subtitle pt-4 pl-2 mb-0">
                Clicca su un studikw per visulizzarne i dettagli. In questa sezione sono presenti gli studikw a cui non è
                stato associato un cliente
              </p>
            </CardHeader>

            {isFilteringClients ? (
              <CardBody>
                <p className="mb-0 text-muted">
                  I report senza cliente non vengono mostrati quando filtri per cliente.
                </p>
              </CardBody>
            ) : (
              <Accordion defaultActiveKey="0" className="mr-5 ml-5 mb-2">
                {reports.length > 0 ? (
                  reports
                    .filter(
                      (x) => getReportClientName(x) === ''
                    )
                    .map((repo) => {
                      return <Report key={repo.id} repo={repo} />;
                    })
                ) : (
                  <Loading />
                )}
              </Accordion>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Listing;
